import React from 'react'
import { useFlags } from 'gatsby-plugin-launchdarkly'
import { getReportingAdapter } from '../reporting/get-reporting-adapter'
import { EventPrefix, Trigger } from '@pathccm/common-analytics/events'

const AVOBBanner: React.FC = () => {
  const { marketingSiteSegmentTransition } = useFlags()
  const reporting = getReportingAdapter(marketingSiteSegmentTransition)

  return (
    <div className='simple-banner' data-theme='dark-fern' style={{ margin: "2rem 0"}}>
      <div className='banner-text'>
        <p>Concerned about cost? Let us take the guesswork out of your insurance.</p>
      </div>
      <a id='avob-link' href='https://www.rula.com/how-much-does-therapy-cost/' className='banner-button rula-secondary-button' onClick={() => {
        reporting.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.AVOB_BANNER_CLICKED,
          },
          properties: {}
        })
      }}>
        Request estimate
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g id='arrow-narrow-right' clipPath='url(#clip0_3710_5260)'>
            <path id='Icon' d='M0.1875 10H13.5208M13.5208 10L8.52083 5M13.5208 10L8.52083 15' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round' />
          </g>
          <defs>
            <clipPath id='clip0_3710_5260'>
              <rect width='20' height='20' fill='white' transform='translate(0.666992)' />
            </clipPath>
          </defs>
        </svg>
      </a>
    </div>
  )
}

export default AVOBBanner
